import { inject, Injectable, signal } from '@angular/core';
import { SiThemeService, ThemeType } from '@siemens/element-ng/theme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private readonly siThemeService = inject(SiThemeService);
    private readonly _currentTheme = signal<ThemeType>('dark');

    public readonly currentTheme = this._currentTheme.asReadonly();

    public initialize(): void {
        this.setTheme('dark');
    }

    public setTheme(mode: ThemeType): void {
        this.siThemeService.applyThemeType(mode);
        this._currentTheme.set(mode);

        // Also update Tailwind dark mode class for custom styling
        const htmlElement = document.documentElement;
        const resolvedMode = mode === 'auto' ? this.getSystemPreference() : mode;

        if (resolvedMode === 'dark') {
            htmlElement.classList.add('app--dark');
            htmlElement.setAttribute('data-mode', 'dark');
        } else {
            htmlElement.classList.remove('app--dark');
            htmlElement.removeAttribute('data-mode');
        }
    }

    public toggleTheme(): void {
        const current = this._currentTheme();
        const resolvedCurrent = current === 'auto' ? this.getSystemPreference() : current;
        const newTheme: ThemeType = resolvedCurrent === 'dark' ? 'light' : 'dark';
        this.setTheme(newTheme);
    }

    public isDarkMode(): boolean {
        const current = this._currentTheme();
        return current === 'auto' ? this.getSystemPreference() === 'dark' : current === 'dark';
    }

    private getSystemPreference(): 'light' | 'dark' {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
}
